import { toast } from "sonner";
import { api, formatApiErrorDetail } from "./api";

// POST a "convert to deal" endpoint, warn (never block) on conflict overlaps, then open the deal.
export async function convertToDeal(path, nav) {
    try {
        const { data } = await api.post(path);
        const deal = data.deal;
        toast.success(data.created ? `Deal created: ${deal.company_name}` : `Already a deal: ${deal.company_name}`);
        const n = (data.conflict_matches || []).length;
        if (n > 0) {
            toast.warning(`${n} possible conflict${n > 1 ? "s" : ""} with existing contacts or deals — review before progressing.`,
                { duration: 9000 });
        }
        nav(`/deals/${deal.id}${n > 0 ? "?conflict=1" : ""}`);
        return deal;
    } catch (err) {
        toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Could not convert to a deal");
        return null;
    }
}
